import { get } from 'lodash';
import { getCurrentLocaleCode } from 'utils/l10n';

export default function getContentfulField(field, lang) {
  return get(field, [lang || getCurrentLocaleCode(false)]);
}
